import { render, staticRenderFns } from "./EditPromotion.vue?vue&type=template&id=352dc2e8&scoped=true&"
import script from "./EditPromotion.vue?vue&type=script&lang=js&"
export * from "./EditPromotion.vue?vue&type=script&lang=js&"
import style0 from "./EditPromotion.vue?vue&type=style&index=0&id=352dc2e8&prod&scoped=true&lang=css&"
import style1 from "./EditPromotion.vue?vue&type=style&index=1&id=352dc2e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352dc2e8",
  null
  
)

export default component.exports